/**
 * Exhaustive tracker dispatch — adding a tracker must break every switch
 * that does not handle it, at compile time.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { TrackerId } from './tracker-registry';

/** Compile-time exhaustiveness guard for `switch` defaults. */
export function assertNever(value: never, context = 'value'): never {
  throw new Error(`Unhandled ${context}: ${String(value)}`);
}

/** One arm per tracker; a missing arm is a type error. */
export function matchTracker<T>(id: TrackerId, arms: { [K in TrackerId]: () => T }): T {
  return arms[id]();
}
